import React from 'react';
import { PropTypes } from 'prop-types';
import { Link as LinkButton } from '@ontruck/orc';
import TextIcon from 'components/TextIcon';
import Tag from 'components/Tag';
import { useTranslation } from 'react-i18next';

const EmptyValue = ({ setEdit, toEditLabel, isGrey, isNew }) => {
  const { t } = useTranslation();

  return (
    <div className={`bottom ${isGrey ? 'grey' : ''}`} data-testid="empty-value">
      <button type="button" onClick={setEdit}>
        <div className="add-btn">
          <TextIcon className="icon">+</TextIcon>
          <LinkButton onClick={setEdit} text={toEditLabel} size="L" />
        </div>
      </button>
      {isNew && <Tag label={t('AdditionalDocuments:new')} />}
    </div>
  );
};

EmptyValue.propTypes = {
  toEditLabel: PropTypes.string,
  isGrey: PropTypes.bool,
  isNew: PropTypes.bool,
  setEdit: PropTypes.func,
};

EmptyValue.defaultProps = {
  toEditLabel: '',
  isGrey: false,
  isNew: false,
  setEdit: () => ({}),
};

export default EmptyValue;
